import { render, staticRenderFns } from "./RsaConfigurazioneDiariListComponent.vue?vue&type=template&id=f80a6a16"
import script from "./RsaConfigurazioneDiariListComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneDiariListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports